
import { useTranslation } from "react-i18next";


const EditEmployesAttachments = ({
  setName,
  setType,
  name,
  type,
  setExpiredAt,expired_at
}) => {

  const { t } = useTranslation();

  const handelNameChange = (e) => {
    const file = e.target.files[0];
    setName(file);
  };
  const handelTypeChange = (e) => {
    const { value } = e.target;
    setType(value);
  };
  const handelDateChange = (e) => {
    const { value } = e.target;
    setExpiredAt(value);
  };


  return (
    <div className="container">
      <div className="row">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="name">{t("File")}</label>
                  <input
                    type="file"
                    accept="pdf/image"
                    className="form-control"
                    onChange={handelNameChange}
                  />
                  <img src={name} alt="image"  className="img-fluid"/>
                </div>
                <div className="form-group">
                  <label htmlFor="">{t("Expired_at")}</label>
                  <input
                    type="date"
                    className="form-control"
                    value={expired_at}
                    onChange={handelDateChange}
                  />
                </div>
              </div>
              <div className="col-lg-6">
         
                <div className="form-group">
                  <label htmlFor="">{t("Type")}</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={handelTypeChange}
                    value={type}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEmployesAttachments;
